import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PublicOnlyRoute({ children }) {
  const { loading, authenticated } = useAuth();
  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>Loading...</div>;
  if (authenticated) return <Navigate to="/" replace />;
  return children;
}
